// extracted by mini-css-extract-plugin
module.exports = {"container":"talents_container_2GT5Q"};